(function ($) {
  'use strict';

  $(document).ready(function () {
    // Toggle menu sub-elements.
    $('.menu__item.more').click(function (e) {
      if (e.target !== $(this)[0] && !$(e.target).hasClass('nolink')) {
        return true;
      }
      var $element;
      if ($(e.target).hasClass('nolink')) {
        // Make span.nolink clickable.
        $element = $(e.target).parent();
      }
      else {
        $element = $(e.target);
      }
      $element.find('> .menu').slideToggle();
      $element.toggleClass('is-expanded');
    });
  });
})(jQuery);
